/** FOUNDER'S PICK — founder-curated artist (migration 043). Same muted style as ARCHIVE LEGEND. */
import React from 'react';

export default function FounderPickTag() {
  return <span className="ax-tag ax-tag--legend ax-tag--founder">FOUNDER&#39;S PICK</span>;
}
